const SliderData = [
  {
    id: 1,
    imgS:"https://res.cloudinary.com/talhakash/image/upload/v1618825420/iyhe9bzben0kahbese8h.jpg",
    Title: "TaLhA eCommerce Website",
    Subtitle: " Tiny and Perfect Reactjs Site",
    Description:"Shop is a website Which is Created By  TaLhA Zubair MaYo Using  React  ",
  },
  {
    id: 2,
    imgS:"https://res.cloudinary.com/talhakash/image/upload/v1618825420/gcnts5bjfovqrdmhplpt.jpg",
    Title: "Made With Love",
    Subtitle: "Slider Item 2",
    Description: "Please Give Your valuable Suggestion To Improve My skills In Better Way",
  },
{
  id: 3,
  imgS:"https://res.cloudinary.com/talhakash/image/upload/v1618825420/ylv8vszl0p50mdqfohdn.jpg"
  ,
  Title: "Proident occaecat",
  Subtitle: "Slider Item 3",
  Description: "MERN Stack Version will Be Created Soon And It Will Be Updated as A Full Satack Web Soon InshAllah . Thank you",
},
];

const CategoryMonthData = [
    {
      id: 1,
      img:"https://res.cloudinary.com/talhakash/image/upload/v1618827551/x0mxrjd1q0avnotthsme.jpg",
      Namee:"Watches"
    },
    {
      id: 2,
      img:"https://res.cloudinary.com/talhakash/image/upload/v1618827552/mnibpnpwkl5yemhjrfh8.jpg",
      Namee:"Shoes"
      },
  {
    id: 3,
    img:"https://res.cloudinary.com/talhakash/image/upload/v1618827552/az0ijoamzwiftmkd4who.jpg"
    ,
    Namee:"Accessories"
    },
  ];

  const FeaturedData = [
    {
      id: 1,
      Fimg:"https://res.cloudinary.com/talhakash/image/upload/v1618827552/cp0zxrbmeohemva9j8qx.jpg",
      Ftitle:"Flash Light",
      price:240,
      Description:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt in culpa qui officia deserunt.",
      reviews:"24"
     
    },
    {
      id: 2,
      Fimg:"https://res.cloudinary.com/talhakash/image/upload/v1618827552/rmwqtf1p3ravm7i4crm4.jpg",
      Ftitle:"Watches",
      price:480,
      Description:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt in culpa qui officia deserunt.",
      reviews:"24"
      },
  {
    id: 3,
    Fimg:"https://res.cloudinary.com/talhakash/image/upload/v1618827553/yyvk8gd8d8nmie12hs3z.jpg"
    ,
    Ftitle:"Camera",
    price:1000,
    Description:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt in culpa qui officia deserunt.",
    reviews:"24"
   
    },
  ];


export  {SliderData, CategoryMonthData ,FeaturedData};